export default __webpack_public_path__ + "static/media/photo-2@2x.dba98abb.png";